// 引入moment的多语言，默认包含英文

export default {
  'react-intl': {
    en: {
      messages: require('./en.json'),
      locale: require('@formatjs/intl-relativetimeformat/dist/locale-data/en'),
    },
    ar: {
      messages: require('./ar.json'),
      locale: require('@formatjs/intl-relativetimeformat/dist/locale-data/ar'),
    },
  },
  antd: {
    en: require('antd/es/locale/en_US'),
    ar: require('antd-mobile/lib/locale-provider/en_US'),
  },
  moment: {
    en: 'en-US',
    ar: 'ar',
  },
}

export { default as messages } from './messages'
